import {ENDPOINT_EHP} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const getReviewById = (token, entityId) => {
  let ehpEndPoint = `${ENDPOINT_EHP}review/${entityId}`;

  return fetch(ehpEndPoint, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const callGetReviewById = ({token, entityId}) => {
  return getReviewById(token, entityId);
};

export default {
  getReviewById,
  callGetReviewById,
};
